import withColorQuery, { WithColorQueryProps } from 'enhancers/withColorQuery';
import withCountry from 'enhancers/withCountry';
import isExternal from 'is-url-external';
import * as React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { getTextColor } from 'utils/colors';

interface IProps {
  onClick?: (e?: React.MouseEvent<HTMLSpanElement>) => void;
  children: React.ReactNode;
  background?: string;
  type?: 'button' | 'submit';
  disabled?: boolean;
  link?: string;
  className?: string;
  external?: boolean;
  target?: string;
}

type Props = IProps & WithColorQueryProps;

export const Button: React.SFC<Props> = props => {
  const buttonElement = (
    <StyledButton
      disabled={props.disabled}
      type={props.type}
      className={props.className}
      background={
        props.background ||
        (!props.loading && props.data && props.data.fetch.Common.ButtonColor
          ? props.data.fetch.Common.ButtonColor
          : '#81d8c3')
      }
    >
      {props.children}
    </StyledButton>
  );

  if (!props.disabled && props.link) {
    if (isExternal(props.link) || props.external) {
      return (
        <a href={props.link} target={props.target}>
          {buttonElement}
        </a>
      );
    }

    return (
      <StyledLink target={props.target} to={props.link}>
        {buttonElement}
      </StyledLink>
    );
  }
  return <span onClick={props.onClick}>{buttonElement}</span>;
};

export const StyledLink = styled(Link)`
  color: inherit;
`;

export const StyledButton = styled.button<{ background: string }>`
  background: ${props => props.background};
  background-color: transparent;
  padding: 12px 35px;
  text-transform: uppercase;
  cursor: pointer;
  color: ${props => getTextColor(props.background)};
  border: 2px solid #81d8c3;
  font-size: 14px;
  -o-transition: 0.3s;
  -ms-transition: 0.3s;
  -moz-transition: 0.3s;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  &:disabled {
    color: grey;
    border-color: grey;
    cursor: not-allowed;
  }
  &:hover {
    background-color: #81d8c3;
  }
  @media (max-width: 900px) {
    font-size: 14px;
    padding: 6px 18px;
  }
`;

export default withCountry(withColorQuery(Button));



// WEBPACK FOOTER //
// ./src/components/Button/Button.tsx